import { render, staticRenderFns } from "./PlantillasWhatsApp.vue?vue&type=template&id=ee882240&scoped=true"
import script from "./PlantillasWhatsApp.vue?vue&type=script&lang=js"
export * from "./PlantillasWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./PlantillasWhatsApp.vue?vue&type=style&index=0&id=ee882240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee882240",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
